import React, { useState, useEffect } from "react";
import { useUpdateItem } from "../../_helper/actions/mutation/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { toast } from "react-toastify";

const EditBatchModal = ({ batch, isOpen, onClose, onSave }) => {
  const [batchName, setBatchName] = useState("");
  const [batchNo, setBatchNo] = useState("");
  const [batchPrice, setBatchPrice] = useState("");
  const [mrp, setMrp] = useState("");

  // Initialize the form fields when the batch prop changes
  useEffect(() => {
    if (batch) {
      setBatchName(batch.item_id?.items_name || "");
      setBatchNo(batch.batch_no || "");
      setBatchPrice(batch.batch_price || "");
      setMrp(batch.price || "");
    }
  }, [batch]);

  const update_mutation = useUpdateItem(ApiEndPoint.PHARMACY);

  const handleSave = () => {
    update_mutation.mutate(
      {
        data: {
          action: "patchBatch",
          id: batch.id,
          batch_price: batchPrice,
          price: mrp,
        },
      },
      {
        onSuccess: () => {
          toast.success("Successfully Batch is edited!");
          onClose();
        },
      }
    );
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div className="bg-white rounded p-6 w-96">
        <h2 className="text-xl font-semibold mb-4">Edit Batch</h2>

        {/* Batch Name (Disabled) */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Item Name
          </label>
          <input
            type="text"
            value={batchName}
            disabled
            className="w-full border rounded px-3 py-2 bg-gray-100 cursor-not-allowed"
          />
        </div>

        {/* Batch No */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Batch No
          </label>
          <input
            type="text"
            value={batchNo}
            disabled
            onChange={(e) => setBatchNo(e.target.value)}
            className="w-full border rounded px-3 py-2 focus:outline-none focus:ring focus:border-blue-300"
          />
        </div>

        {/* Batch Price */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Batch Price
          </label>
          <input
            type="number"
            value={batchPrice}
            onChange={(e) => setBatchPrice(e.target.value)}
            className="w-full border rounded px-3 py-2 focus:outline-none focus:ring focus:border-blue-300"
          />
        </div>

        {/* MRP */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            MRP
          </label>
          <input
            type="number"
            value={mrp}
            onChange={(e) => setMrp(e.target.value)}
            className="w-full border rounded px-3 py-2 focus:outline-none focus:ring focus:border-blue-300"
          />
        </div>

        {/* Action Buttons */}
        <div className="flex justify-end space-x-2">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400 text-gray-800"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="px-4 py-2 rounded bg-blue-600 hover:bg-blue-700 text-white"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditBatchModal;
